import { render, staticRenderFns } from "./regularWork.vue?vue&type=template&id=001ed1b4&"
import script from "./regularWork.vue?vue&type=script&lang=js&"
export * from "./regularWork.vue?vue&type=script&lang=js&"
import style0 from "./regularWork.vue?vue&type=style&index=0&id=001ed1b4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports